import {
    createStyles,
    IconButton,
    InputAdornment,
    TextField,
    Theme,
    withStyles,
    WithStyles,
} from "@material-ui/core";
import { SendRounded } from "@material-ui/icons";
import classNames from "classnames";
import React from "react";
import { Id } from "shared/src/models/framework/db";
import { Mode } from "shared/src/models/poll";
import { PollCard } from "shared/src/network/requests/poll/poll-req-models";
import { Analytic } from "../analytic/analytic";
import { commonClasses, spacing } from "../styles";
import { colors } from "../theme";

const styles = (theme: Theme) =>
    createStyles({
        ...commonClasses,
        ...spacing(theme),
        commentInput: {
            "& .MuiInputBase-root": {
                borderRadius: 20,
                padding: 0,
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: colors.brand.blue.main,
                },
            },
            "& input": {
                padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
            },
        },
        sendButton: {
            padding: theme.spacing(0.5),
            color: colors.brand.blue.main,
        },
    });

type Props = WithStyles<typeof styles> & {
    onCommentSend?: (comment: string) => Promise<void> | undefined;
    onFocus?: () => void;
    autoFocus?: boolean;
    poll: Id<PollCard>;
    mode?: Mode;
};

type State = {
    comment: string;
};

class Component extends React.Component<Props, State> {
    inputRefs: React.RefObject<HTMLInputElement>;
    constructor(props: Props) {
        super(props);
        this.state = { comment: "" };
        this.inputRefs = React.createRef();
    }

    handleCommentInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ comment: event.target.value });
    };

    handleSendClick = async () => {
        const { onCommentSend } = this.props;
        const { comment } = this.state;
        if (!comment.trim()) return;
        await onCommentSend?.(comment.trim());
        this.setState({ comment: "" });
    };

    onKeyPress = (evt: React.KeyboardEvent) => {
        if (evt.key === "Enter") {
            const { poll, mode } = this.props;
            this.handleSendClick();

            const eventName = mode === "YOURPOLL" ? "your_poll_comment_add" : "poll_comment_add";
            Analytic.addEvent({
                event: eventName,
                question: JSON.stringify(poll.questionText),
                defaultGTMConfig: "false",
            });
        }
    };

    onFocus = () => {
        const { onFocus } = this.props;
        if (!!onFocus) {
            if (!!this.inputRefs) this.inputRefs.current?.blur();
            onFocus();
        }
    };

    render = () => {
        const { classes, autoFocus, poll, mode } = this.props;
        const { comment } = this.state;
        return (
            <TextField
                className={classNames(classes.commentInput, classes.fullWidth)}
                placeholder="Add a public comment..."
                value={comment}
                id={"btn-comment-textbox-" + JSON.stringify(poll.questionText)}
                data-event="poll_comment_text_box_click"
                onFocus={this.onFocus}
                onChange={this.handleCommentInput}
                onKeyPress={this.onKeyPress}
                autoFocus={!!autoFocus}
                inputRef={this.inputRefs}
                autoComplete="off"
                InputProps={{
                    sx: {
                        fontSize: "14px",
                    },
                    endAdornment: (
                        <InputAdornment>
                            <IconButton
                                size="small"
                                id={"btn-comment-send-" + poll.id}
                                data-event={
                                    mode === "YOURPOLL"
                                        ? "your_poll_comment_add"
                                        : "poll_comment_add"
                                }
                                data-question={JSON.stringify(poll.questionText)}
                                className={classes.sendButton}
                                onClick={this.handleSendClick}>
                                <SendRounded />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        );
    };
}

const CommentInput = withStyles(styles)(Component);

export default CommentInput;
